import type { HTMLAttributes } from "react";

export default function PinIcon(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.17747 0.21852C3.31592 0.0791598 3.50398 0.000559005 3.70029 2.97016e-06C3.89661 -0.000553065 4.08511 0.0769814 4.22434 0.215555C4.29779 0.290523 4.35456 0.380205 4.39092 0.478706C5.0069 1.76555 5.68508 2.49125 6.54093 2.91971C7.50118 3.39412 8.60358 3.72398 10.3804 3.72398C10.5266 3.72467 10.6693 3.76841 10.7908 3.84973C10.9124 3.93106 11.0073 4.04639 11.0638 4.18134C11.1197 4.31685 11.1343 4.46591 11.1058 4.60971C11.0772 4.75351 11.0067 4.88561 10.9031 4.98933L8.50215 7.39326C8.50215 7.39326 12.8195 10.9897 11.8612 11.8779C10.9028 12.7662 7.38198 8.5148 7.38198 8.5148L4.98173 10.918C4.91297 10.9874 4.83086 11.0421 4.74037 11.0789C4.65005 11.1167 4.5538 11.1367 4.45756 11.1367C4.36131 11.1367 4.26506 11.1167 4.17474 11.0789C4.03935 11.0232 3.92354 10.9286 3.84207 10.8069C3.76059 10.6852 3.71712 10.5419 3.7172 10.3954C3.7172 8.61636 3.38847 7.51261 2.91538 6.56601C2.4882 5.7091 1.76338 5.0301 0.477377 4.41336C0.379047 4.37729 0.28965 4.3204 0.21529 4.24658C0.0768862 4.10718 -0.000552177 3.91844 2.86102e-06 3.72189C0.000557899 3.52533 0.0790606 3.33704 0.21825 3.19842L3.17747 0.21852Z"
        fill="currentColor"
      />
    </svg>
  );
}
